<button class="markerDs__cont markerDs__cont--{{type}}" aria-label="markerDs" [class.closed]="!isOpenLocationTag" (click)="clickEventEmit()">
  <ng-container *ngIf="!isLocationMarker; else locationTag">
    <div class="markerDs__tag">
      <ng-container *ngIf="icon">
        <app-ds-icon
          class="markerDs__tag-icon"
          [icon]="icon"
          [size]="iconSize"
          [color]="iconColor">
        </app-ds-icon>
      </ng-container>
      <app-ds-typography
        [size]="fontSize"
        [text]="label"
        [fontFamily]="typographyFontFamily.SemiBold"
        [color]="fontColor">
      </app-ds-typography>
    </div>
  </ng-container>
</button>

<ng-template #locationTag>
  <div class="markerDs__location-tag" [class.closed]="!isOpenLocationTag">
    <ng-container *ngIf="isOpenLocationTag">
      <div class="markerDs__location-tag-address">
        <div class="markerDs__location-tag-address-main">
          <app-ds-typography
            [size]="typographyFontSize.XXS"
            [text]="address?.MainText"
            [fontFamily]="typographyFontFamily.SemiBold"
            [color]="fontColor">
          </app-ds-typography>
          <app-ds-icon
            class="markerDs__location-tag-address-main-icon"
            [icon]="closeIcon"
            [color]="iconColor"
            [size]="16"
            (click)="closeLocation($event)">
          </app-ds-icon>
        </div>
        <div class="markerDs__location-tag-address-info">
          <app-ds-typography
            [size]="typographyFontSize.XXXS"
            [text]="address?.City"
            [color]="typographyColorSecondary">
          </app-ds-typography>
          <app-ds-typography
            [size]="typographyFontSize.XXXS"
            [text]="address?.Country"
            [color]="typographyColorSecondary">
          </app-ds-typography>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!isOpenLocationTag">
      <div class="markerDs__location-tag-icon">
        <app-ds-icon
          [icon]="locationIcon"
          [color]="iconColor"
          [size]="30">
        </app-ds-icon>
      </div>
    </ng-container>
  </div>
</ng-template>